import { useSearchResultsLayer } from '../hooks'

import GraphicLayer from '../../map/components/GraphicLayer'

const SearchResultsLayer = ({ mapId }) => {
  const [{ map, view, graphics }] = useSearchResultsLayer(mapId)

  return (
    <GraphicLayer
      id="searchResults"
      map={map}
      view={view}
      graphics={graphics}
    />
  )
}


export default SearchResultsLayer